import React from "react";
import { useTranslation } from "react-i18next";

const HotelsTableHeader = () => {
  const { t } = useTranslation();
  return (
    <thead>
      <tr>
        <th>{t("bookingDetails.hotels.from")}</th>
        <th>{t("bookingDetails.hotels.to")}</th>
        <th>{t("bookingDetails.hotels.hotel")}</th>
        <th>{t("bookingDetails.hotels.accomodation")}</th>
        <th>{t("bookingDetails.hotels.catering")}</th>
      </tr>
    </thead>
  );
};

export default HotelsTableHeader;
